const OsnovniSeznam = () => import("@views/app/user-contract-list/user-contract-list.vue");

export const seznamNakupovRoutes = [
    {
        component: OsnovniSeznam,
        name: "osnovni_seznam",
        path: "seznam-pogodb"
    }
];